import { useDispatch, useSelector } from 'react-redux';

import getActualShareLink from '@components/common/Sharing/SharingModal/SharingContent/getActualShareLink';
import { MODE_ALERT_DIAGNOSTICS } from '@store/trends/constants';
import { setActiveDashboardId } from '@store/dashboards/ui/actions';
import { modeSelector } from '@store/trends/selectors';
import { alertSelector } from '@store/trends/alerts/selectors';
import { selectedCustomerIdSelector } from '@store/common/selectors';
import { useDefaultLandingPageStore, usePromptStore } from '@globalStore/defaultLandingPageStore';
import { useDefaultLandingPageMutation } from '@hooks/useDefaultLandingPage';

function useDefaultLandingPage() {
  const dispatch = useDispatch();
  const { mode } = useSelector(modeSelector);
  const { alert } = useSelector(alertSelector);
  const cid = useSelector(selectedCustomerIdSelector);

  const defaultLandingPage = useDefaultLandingPageStore((state) => ({
    url: state.url,
    name: state.name,
    path: state.path,
  }));

  const { setDefaultLandingPage: mutateLandingPage } = useDefaultLandingPageMutation();

  const { openPrompt, setPromptState } = usePromptStore();

  const onSetDefaultLandingApply = () => {
    const { pathname } = window.location;
    const arr = pathname.split('/');
    const u = getActualShareLink(pathname, cid);
    if (mode === MODE_ALERT_DIAGNOSTICS) {
      mutateLandingPage({ url: u, name: `Alert: ${alert.name}`, path: pathname });
    } else {
      mutateLandingPage({ url: u, name: arr[arr.length - 1], path: pathname });
    }
  };

  const onSetDefaultLanding = () => {
    const hasDefaultLandingPage = defaultLandingPage.url.length > 0;
    const content = hasDefaultLandingPage
      ? 'Are you sure you want to change your default dashboard?'
      : 'Are you sure you want to set your default dashboard?';
    const obj = {
      title: 'Make default',
      content,
      okFn: () => onSetDefaultLandingApply(),
      needInput: false,
    };
    dispatch(setActiveDashboardId(null));

    // Use Zustand actions instead of Redux dispatch
    setPromptState({
      promptNeedInput: obj.needInput,
      promptTitle: obj.title,
      promptContent: obj.content,
      promptOkFn: obj.okFn,
    });
    openPrompt();
  };

  return { onSetDefaultLanding };
}

export default useDefaultLandingPage;
